import * as ACTION from './constants';
import { arrayMerge } from '../../utils';

const initialState = {
  demos: [],
  images: [],
  videos: [],
  isLoadingDemos: false,
  isLoadingImages: false,
  isLoadingVideos: false,

};

export default function reducers(state = initialState, action) {
  switch(action.type) {
    case ACTION.MEDIA_BASE:
      return {...initialState};
    case ACTION.DEMOS_QUERY:
      return {...initialState,
        isLoadingDemos: true
      };
    case ACTION.LIBRARY_DEMO_LOADING:
      return {...state,
        isLoadingDemos: true
      };
    case ACTION.LIBRARY_DEMO_LOADED:
      return {...state,
        isLoadingDemos: false,
        demos: arrayMerge(state.demos, action.demos),
        totalDemoCount: action.totalCount
      };
    case ACTION.LIBRARY_DEMO_ADDED:
      return {...state,
        demos: action.demos,
        totalDemoCount: action.totalCount
      };
    case ACTION.LIBRARY_DEMO_ASSIGNED:
      return {...state,
        demos: action.demos,
        totalDemoCount: action.totalCount
      };
    case ACTION.IMAGES_QUERY:
        return {...initialState,
          isLoadingImages: true
        };
    case ACTION.LIBRARY_IMAGES_LOADING:
      return {...state,
        isLoadingImages: true
      };
    case ACTION.LIBRARY_IMAGES_LOADED:
      return {...state,
        isLoadingImages: false,
        images: arrayMerge(state.images, action.images),
        totalImageCount: action.totalCount
      };
    case ACTION.VIDEOS_QUERY:
        return {...initialState,
          isLoadingVideos: true
        };
    case ACTION.LIBRARY_VIDEOS_LOADING:
      return {...state,
        isLoadingVideos: true
      };
    case ACTION.LIBRARY_VIDEOS_LOADED:
      return {...state,
        isLoadingVideos: false,
        videos: arrayMerge(state.videos, action.videos),
        totalVideoCount: action.totalCount
      };
    default:
      return state;
  }
}
